import { AUD, CAD, GBP, USD, EUR, Currency } from "money/index"

export class Region {
  readonly code: string
  readonly currency: Currency

  constructor(code: string, currency: Currency) {
    this.code = code
    this.currency = currency
  }

  sameAs = (other: Region): boolean => this.code === other.code
}

export const AU = new Region(`au`, AUD)
export const CA = new Region(`ca`, CAD)
export const UK = new Region(`uk`, GBP)
export const US = new Region(`us`, USD)
export const EU = new Region(`eu`, EUR)
export const ROW = new Region(`row`, USD)

const regionsByCode: Record<string, Region> = {
  au: AU,
  ca: CA,
  uk: UK,
  us: US,
  eu: EU,
  row: ROW
}

export const fromCode = (code: string): Region => {
  const region = regionsByCode[code.toLowerCase()]
  if (!region) {
    throw new Error(`Unknown region code: ${code}`)
  } else {
    return region
  }
}
